"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class Chat extends Parse.Object {
    constructor(attributes) {
        super('Chat', attributes);
    }
    /** The omnichat customer associated to this chat */
    get customer() {
        return this.get('customer');
    }
    set customer(value) {
        this.set('customer', value);
    }
    /** The omnichat team associated to this chat. it is mutually exlusive with salesPerson */
    get team() {
        return this.get('team');
    }
    set team(value) {
        this.set('team', value);
    }
    /** Current salesperson responsible for chatting with the associated customer. it is mutually exlusive with team */
    get salesPerson() {
        return this.get('salesPerson');
    }
    set salesPerson(value) {
        this.set('salesPerson', value);
    }
    /** The user resposible for this chat. New customer supports will always be associated to this user */
    get owner() {
        return this.get('owner');
    }
    set owner(value) {
        this.set('owner', value);
    }
    get lastFinishedBy() {
        return this.get('lastFinishedBy');
    }
    set lastFinishedBy(value) {
        this.set('lastFinishedBy', value);
    }
    get originTeam() {
        return this.get('originTeam');
    }
    set originTeam(value) {
        this.set('originTeam', value);
    }
    /** Current salesperson responsible for chatting with the associated customer */
    get currentOrder() {
        return this.get('currentOrder');
    }
    set currentOrder(value) {
        this.set('currentOrder', value);
    }
    /** The number of underead messages related tthis chat */
    get unreadMessagesCount() {
        return this.get('unreadMessagesCount');
    }
    set unreadMessagesCount(value) {
        this.set('unreadMessagesCount', value);
    }
    /** The retailer this chat belongs to */
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    /**
     * When the customer send the first message a support request is
     * created before the chat gets associated to a sales person
     */
    get customerSupportRequest() {
        return this.get('customerSupportRequest');
    }
    set customerSupportRequest(value) {
        this.set('customerSupportRequest', value);
    }
    /** All previous customer support requestes that this chat recevied */
    get previousCustomerSupportRequests() {
        return this.get('previousCustomerSupportRequests');
    }
    set previousCustomerSupportRequests(value) {
        this.set('previousCustomerSupportRequests', value);
    }
    /** The unique facebook id related to the facebook user that this chat is related to */
    get platform() {
        return this.get('platform');
    }
    set platform(value) {
        this.set('platform', value);
    }
    /** Additional Facebook information related to the facebook customer */
    get meta() {
        return this.get('meta');
    }
    set meta(value) {
        this.set('meta', value);
    }
    /** The unique facebook id related to the facebook user that this chat is related to */
    get labels() {
        return this.get('labels');
    }
    set labels(value) {
        this.set('labels', value);
    }
    /**
     * The unique facebook id related to the facebook user that this chat is related to
     * The id is unique per facebook page, will not going to have duplications between
     * distinct retaliers
     * DEPRECATED: use chatId
     */
    get fbMessengerId() {
        return this.get('fbMessengerId');
    }
    set fbMessengerId(value) {
        this.set('fbMessengerId', value);
    }
    /** DEPRECATED: use chatId The whatsapp phone this chat is related to */
    get whatsAppId() {
        return this.get('whatsAppId');
    }
    set whatsAppId(value) {
        this.set('whatsAppId', value);
    }
    /** The external identifier related to the chat plataform */
    get chatId() {
        return this.get('chatId');
    }
    set chatId(value) {
        this.set('chatId', value);
    }
    /**
     * The retailer chatId that the customer has contantaced.
     * this property is mainly needed when the retailer has multiple
     * whatsapps for example
     */
    get retailerChatId() {
        return this.get('retailerChatId');
    }
    set retailerChatId(value) {
        this.set('retailerChatId', value);
    }
    get canonicalSearch() {
        return this.get('canonicalSearch');
    }
    set canonicalSearch(value) {
        this.set('canonicalSearch', value);
    }
    /** The last message associated with this chat  */
    get lastMessage() {
        return this.get('lastMessage');
    }
    set lastMessage(value) {
        this.set('lastMessage', value);
    }
    /** The date that the last message associated with this chat was sent  */
    get lastMessageDate() {
        return this.get('lastMessageDate');
    }
    set lastMessageDate(value) {
        this.set('lastMessageDate', value);
    }
    /** The date that the last message associated with this chat was sent  */
    get snoozedUntil() {
        return this.get('snoozedUntil');
    }
    set snoozedUntil(value) {
        this.set('snoozedUntil', value);
    }
    get allCustomerSupportRequests() {
        return this.get('allCustomerSupportRequests');
    }
    set allCustomerSupportRequests(allCSR) {
        this.set('allCustomerSupportRequests', allCSR);
    }
    /**
     * Field to the engine control the status, avoiding eternal loops or dead locks
     */
    set engineStatus(status) {
        this.set('engineStatus', status);
    }
    get engineStatus() {
        return this.get('engineStatus');
    }
    set internalState(status) {
        this.set('internalState', status);
    }
    get internalState() {
        return this.get('internalState');
    }
    set expiresAt(date) {
        this.set('expiresAt', date);
    }
    get expiresAt() {
        return this.get('expiresAt');
    }
    set externalInfo(date) {
        this.set('externalInfo', date);
    }
    get externalInfo() {
        return this.get('externalInfo');
    }
    set offlineSince(date) {
        this.set('offlineSince', date);
    }
    get offlineSince() {
        return this.get('offlineSince');
    }
    /** Attomically increment the unread message count */
    incrementUnreadMessagesCount() {
        this.increment('unreadMessagesCount');
    }
    set customerSupportRequestDate(date) {
        this.set("customerSupportRequestDate", date);
    }
    get customerSupportRequestDate() {
        return this.get("customerSupportRequestDate");
    }
    set firstUnansweredMessageDate(date) {
        this.set("firstUnansweredMessageDate", date);
    }
    get firstUnansweredMessageDate() {
        return this.get("firstUnansweredMessageDate");
    }
}
exports.Chat = Chat;
Parse.Object.registerSubclass('Chat', Chat);
//# sourceMappingURL=Chat.js.map